/**
 * オーバーレイ画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const BoardGL = {
  /**
   * 初回アクセス画面用グロッサリID
   */
  /** image.canon Welcome to the subscription store */
  WelcomeTitle: 'GL00300001',
  /** *Please select your country / region before entering the store. */
  NoteTop: 'GL00300002',
  /** *When you log in with your Canon ID, the registered country / region / language will be reflected. */
  NoteBottom: 'GL00300003',
  /** Select a country / region */
  CountryButton: 'GL00300004',
  /** Log in with your Canon ID */
  logInButton: 'GL00300005',
  /**
   * 言語選択画面用グロッサリID
   */
  /** Please select the language used on this page */
  SelectLanguageMessage: 'GL00301001',
  /**
   * 国地域選択画面用グロッサリID
   */
  /** Please select a sales company in your country / region */
  SelectCountryMessage: 'GL00302001',
  /**
   * メニューグロッサリID
   */
  /** プラン一覧 */
  PlanListMenu: 'GL00303001',
  /** プランの管理(MENU_0001) */
  ContractListMenu: 'GL00303002',
  /** 利用ガイド */
  GuideMenu: 'GL00303003',
  /** FAQ */
  Faq: 'GL00303004',
  /** お問い合わせ */
  ContactUs: 'GL00303005',
  /** 利用規約 */
  TermsOfService: 'GL00303006',
  /** プライバシーポリシー */
  PrivacyPolicy: 'GL00303007',
  /** クッキーポリシー */
  CookiePolicy: 'GL00303008',
  /** image.canon トップへ */
  ToImageCanonTop: 'GL00303009',
  /** News */
  News: 'GL00303010',
  /** プロフィールの編集 */
  EditProfile: 'GL00303011',
  /** ログアウト */
  Logout: 'GL00303012',
  /** 購入履歴 */
  PurchaseHistory: 'GL00303013',
  /** サードパーティ製ソフトウェアについて */
  AboutSoftware: 'GL00303014',
  /**
   * 購入確認画面ID
   */
  /** ご購入前に */
  BeforePurchaseBoardTitle: 'GL00304001',
  /** 注記コメント */
  BeforePurchaseBoardNote: 'GL00304002',
  /** 詳しい条件を確認する */
  ConfirmationTermsOfService: 'GL00304003',
  /** 購入手続きへ進む */
  GoToPurchase: 'GL00304004',
  /** 上記内容に同意する */
  AgreementCheckboxLabel: 'GL00304005',
  /** 上記内容に同意する (購入前の注記への同意) */
  PurchaseNotesAgreementCheckboxLabel: 'GL00304007',
  /** 上記条件に同意する (利用規約への同意) */
  PurchaseTermsAgreementCheckboxLabel: 'GL00304008',
  /**
   * 解約確認画面ID
   */
  /** ご解約の前に */
  BeforeCancelBoardTitle: 'GL00305001',
  /** 注記コメント */
  BeforeCancelBoardNote: 'GL00305002',
  /** 解約する */
  BeforeCancelBoardExecuteCancel: 'GL00305003',
  /**
   * レンタルの利用登録・解除/解約画面ID
   */
  /** 利用状況 ( {0} / {1} ) */
  usageSituation: 'GL00308001',
  /** ステータス */
  status: 'GL00308002',
  /** 他ユーザー利用 */
  usageByOtherUsers: 'GL00308003',
  /** 使用中 */
  duringUse: 'GL00308004',
  /** 未使用 */
  unused: 'GL00308005',
  /** 解約済み */
  cancelled: 'GL00308006',
  /** あなたが利用中です */
  youUsing: 'GL00308007',
  /** 他ユーザーの管理 / プランの解約 */
  managementAndCancellation: 'GL00308008',
  /** 他ユーザーの利用設定 */
  useSettingUserOther: 'GL00308009',
  /** + 新規設定 */
  newPreference: 'GL00308010',
  /** 他ユーザーを削除する */
  removeOtherUser: 'GL00308011',
  /** プランを解約する */
  cancelPlan: 'GL00308012',
  /** デバイス数 */
  deviceNumber: 'GL00308013',
  /** ユーザー情報が取得できませんでした */
  couldNotGet: 'GL00308014',
  /** チェックを付けてください */
  pleaseWithCheck: 'GL00308015',
  /** 解約済みです。 */
  youCancelled: 'GL00308016',
  /** 未使用のプランです。 */
  unregisteredPlan: 'GL00308017',
  /** すべて選択 */
  allCheck: 'GL00308018',
  /** 利用上限に達している場合は利用設定の削除を行ってください。 */
  pleaseDeleteLendingUser: 'GL00308019',
  /** 有効期限切れ */
  expired: 'GL00308020',
  /**
   * レンタルの利用登録画面ID
   */
  /** 利用設定に失敗しました */
  failedToUseSetting: 'GL00309001',
  /** 入力したメールアドレスがCanonIDに登録されていないか、またはあなた自身のメールアドレスが入力されました。 */
  notCanonID: 'GL00309002',
  /** メールアドレスを入力してください。 */
  pleaseInputEmail: 'GL00309003',
  /** メールアドレス */
  email: 'GL00309004',
  /** 詳しい条件を確認する */
  confirmCriteria: 'GL00309005',
  /** 上記条件に同意する */
  acceptToCriteria: 'GL00309006',
  /** 実行する */
  execute: 'GL00309007',
  /** キャンセル */
  cancel: 'GL00309008',
  /**
   * レンタル停止確認画面ID
   */
  /** 利用設定に失敗しました */
  rentalStopConfirmation: 'GL00310001',
  /**
   * 個別解約確認画面ID
   */
  /** 利用設定に失敗しました */
  cancelConfirmation: 'GL00311001',
  /**
   * 完了/失敗ダイアログID
   */
  /** 利用設定を完了しました。 */
  registered: 'GL00312001',
  /** 利用設定を削除しました。 */
  deleted: 'GL00312002',
  /** 利用設定の削除に失敗しました。 */
  deletingFailure: 'GL00312003',
  /** 解約手続が完了しました。\nご利用ありがとうございました。 */
  cancellationComplete: 'GL00312004',
  /** 解約に失敗しました。 */
  cancellationFailure: 'GL00312005',
  /** OK */
  Ok: 'GL00312006',
  /**
   * 端末管理画面ID
   */
  /** デバイス管理 */
  TerminalBoardTitle: 'GL00306001',
  /** デバイス名 : {0} */
  TerminalBoardDeviceName: 'GL00306002',
  /** デバイスID : {0} */
  TerminalBoardId: 'GL00306003',
  /** 削除 */
  TerminalBoardDelete: 'GL00306004',
  /** 選択されたデバイスを削除しますが、よろしいですか？ */
  TerminalBoardDeleteConfirmationMS: 'GL00306005',
  /** OK */
  TerminalBoardOK: 'GL00306006',
  /** キャンセル */
  TerminalBoardCancel: 'GL00306007',
  /** ご利用中のデバイスを表示しています。利用デバイス数が上限に達している場合、本画面でデバイスを削除することで新しいデバイスが利用可能になります。 */
  TerminalBoardBuyerMS: 'GL00306008',
  /** デバイスを削除しました。 */
  TerminalBoardDeleteSuccessMS: 'GL00306009',
  /** デバイスが削除できませんでした。時間をおいて再度お試しください。 */
  TerminalBoardDeleteFailureMS: 'GL00306010',
  /** デバイス情報が取得できませんでした */
  TerminalBoardCouldNotGet: 'GL00306011',
  /** ご利用中のデバイスはありません */
  TerminalBoardNotRegister: 'GL00306012',
  /**
   * 利用登録解除確認ダイアログID
   */
  /** OK */
  CancellationConfirmationOK: 'GL00307001',
  /** キャンセル */
  CancellationConfirmationCancel: 'GL00307002',
  /** このプランの購入者に返却します。返却すると利用ができなくなります。よろしいですか？ */
  CancellationConfirmationTitle: 'GL00307003',
  /**
   * 機能のアクティベート
   */
  /** カメラの拡張機能の有効化(ACTIVE_0001) */
  ActivateCameraExtensions: 'GL00313001',
  /** アップロード(ACTIVE_0002) */
  ReqFileUpload: 'GL00313002',
  /** アクティベーションファイルのダウンロード(ACTIVE_0007) */
  ActFileDownload: 'GL00313003',
  /** 削除(ACTIVE_0004) */
  ReqFileDelete: 'GL00313004',
  /** カメラで出力したリクエストファイルをアップロードして、カメラを登録ください、PCの利用を推奨します。(ACTIVE_0011) */
  DeviceActivateBoardNote: 'GL00313005',
  /** 選択(ACTIVE_0003) */
  Select: 'GL00313006',
  /** 次へをクリックして、登録されたカメラの拡張機能の有効化の手順に進みます。(ACTIVE_0005) */
  ProceedToDownload: 'GL00313007',
  /** 次へ(ACTIVE_0006) */
  Next: 'GL00313008',
  /** ダウンロード(ACTIVE_0039) */
  Download: 'GL00313009',
  /** アップロード:(アップロード済みの意味)(ACTIVE_0009) */
  UploadDate: 'GL00313010',
  /** リクエストファイルを取得できませんでした(ACTIVE_0036) */
  DeviceActivateBoardCouldNotGet: 'GL00313011',
  /** 登録されていません(ACTIVE_0012) */
  DeviceActivateBoardNotRegister: 'GL00313012',
  /** ファイルの読み込みに失敗しました。(ACTIVE_0020) */
  ReqFileLoadingFailure: 'GL00313013',
  /** ファイル拡張子が異なります。(ACTIVE_0019) */
  ReqFileExtensionFailure: 'GL00313014',
  /** ファイルの内容が不正です。(ACTIVE_0021) */
  ReqFileNecessaryNotContainedFailure: 'GL00313015',
  /** アップロードに失敗しました。(ACTIVE_0018) */
  ReqFileNotUpload: 'GL00313016',
  /** アップロードを開始します。よろしいですか？(ACTIVE_0013) */
  ReqFileUploadConfirmation: 'GL00313017',
  /** OK(ACTIVE_0041) */
  ActivateBoardOK: 'GL00313018',
  /** はい(ACTIVE_0042) */
  Yes: 'GL00313019',
  /** いいえ(ACTIVE_0043) */
  No: 'GL00313020',
  /** 選択のプランでは有効化できない拡張機能が指定されています。(ACTIVE_0014) */
  ReqFileUploadWarningNotActivated: 'GL00313021',
  /** 同時に以下の拡張機能が有効化されます。(ACTIVE_0015) */
  ReqFileUploadWarningActivatedSameTime: 'GL00313022',
  /** ファームウェアのバージョンが古いため有効化できません。カメラを最新のファームウェアにしてやり直してください。(ACTIVE_0023) */
  ReqFileUploadErrorNotAvailable: 'GL00313023',
  /** 選択のプランで有効化できるカメラの台数を超えています。(ACTIVE_0025) */
  ReqFileUploadErrorExcessCameras: 'GL00313024',
  /** 選択のプランでは対象外の機種です。(ACTIVE_0024) */
  ReqFileUploadErrorNotSupported: 'GL00313025',
  /** 選択のプランでは有効化できない拡張機能が指定されています。(ACTIVE_0026) */
  ReqFileUploadErrorNotActivated: 'GL00313026',
  /** 別のプランで既に有効化されているカメラおよび拡張機能が指定されています。(ACTIVE_0027) */
  ReqFileUploadErrorAlreadyActivated: 'GL00313027',
  /** アップロードに失敗しました。(ACTIVE_0028) */
  UploadFailure: 'GL00313028',
  /** アクティベーションファイルのダウンロードに失敗しました。(ACTIVE_0029) */
  DownloadFailure: 'GL00313029',
  /** 削除に失敗しました。(ACTIVE_0030) */
  DeleteFailure: 'GL00313030',
  /** 選択したファイルが上限数(200)を超えています。(ACTIVE_0022) */
  OverSelectedFiles: 'GL00313031',
  /** 削除しますか？(ACTIVE_0032) */
  ReqFileDeleteConfirmation: 'GL00313032',
  /** 既に別のプランで以下の拡張機能は有効化されています。(ACTIVE_0031) */
  ReqFileUploadWarningAlreadyActivated: 'GL00313033',
  /** 既にアップロードされた情報と矛盾するため、このリクエストファイルは無効です。(ACTIVE_0033) */
  ReqFileUploadErrorNotMatch: 'GL00313034',
  /** カメラの拡張機能を有効化するためのアクティベーションファイルをダウンロードします。(ACTIVE_0008) */
  ActFileDownloadConfirmation: 'GL00313035',
  /** ダウンロードしたアクティベーションファイルをメモリカードにコピーし、カメラに挿入して拡張機能の有効化の操作を行ってください。(ACTIVE_0010) */
  ActFileDownloadConfirmationCopyToMemoryCard: 'GL00313036',
  /** アクティベーションファイルのダウンロードを行うと、登録されたカメラの有効化を取り消すことができません。(ACTIVE_0016) */
  ActFileDownloadConfirmationCouldNotCanceled: 'GL00313037',
  /** 複数のカメラが登録された場合にダウンロードされるアクティベーションファイルは1つです。そのファイルで登録された全てのカメラの有効化が行えます。(ACTIVE_0034) */
  ActFileDownloadConfirmationOneFile: 'GL00313038',
  /** アクティベーションファイルを繰り返しダウンロードすることができます。(ACTIVE_0035) */
  ActFileDownloadConfirmationRepeatedly: 'GL00313039',
  /** キャンセル(ACTIVE_0040) */
  Canceled: 'GL00313040',
  /** シリアルナンバー(ACTIVE_0017) */
  SerialNumber: 'GL00313041',
  /** 開始 */
  UploadStarted: 'GL00313042',
  /** リクエストファイルをアップロードしてください */
  PleaseReqFileUpload: 'GL00313043'
} as const;
export type BoardGLKeys = typeof BoardGL[keyof typeof BoardGL];
